import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-encuestaservicios',
  templateUrl: './encuestaservicios.component.html',
  styleUrls: ['./encuestaservicios.component.css'],
})
export class EncuestaServiciosComponent implements OnInit {
  step: 'thanks' | 'followup' | 'done' = 'followup';
  certificateId: string | null = null;

  constructor(private route: ActivatedRoute, private http: HttpClient) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.certificateId = params['certificate_id'];
    });
  }

  handleFollowupVote(rating: number) {
    if (!this.certificateId) return;

    this.http
      // .get('https://b88d0a2f7d45.sn.mynetname.net:4000/api/surveys/feedback/job/company', {
      .get('https://webservice.gar-san.com:8098/api/extranet/surveys/feedback/job/company', {
        params: {
          certificate_id: this.certificateId,
          rate: rating.toString(),
        },
      })
      .subscribe(() => {
        this.step = 'done';
      });
  }
}
